module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad-w540.217d8dac.webp";